import classNames from "classnames";
import React, { ReactNode } from "react";
import { useSelector } from "react-redux";
import {
  MessageType,
  MessageTypeEnum,
  setMessage,
} from "../../../redux/reducers/messageReducer";
import Button from "../../atoms/Button/Button";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch } from "react-redux";
import DangerousIcon from "@mui/icons-material/Dangerous";
import InfoIcon from "@mui/icons-material/Info";
import WarningIcon from "@mui/icons-material/Warning";
import { Snackbar } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

interface MessagesProps {
  logoutUser: () => void;
}

const Messages = (props: MessagesProps) => {
  const { logoutUser } = props;
  const dispatch = useDispatch();
  const message: MessageType = useSelector(
    (state: any) => state.message.message
  );

  if (message !== undefined && message.description === "Unauthorized") {
    logoutUser();
  }

  const handleMessageCloseClick = () => {
    dispatch(setMessage(undefined));
  };

  const getMessageIcon = (messageType: MessageTypeEnum): ReactNode => {
    switch (messageType) {
      case MessageTypeEnum.Error: {
        return <DangerousIcon />;
      }
      case MessageTypeEnum.Info: {
        return <InfoIcon />;
      }
      case MessageTypeEnum.Warning: {
        return <WarningIcon />;
      }
      case MessageTypeEnum.Success: {
        return <CheckCircleIcon />;
      }
      default: {
        return <></>;
      }
    }
  };

  if (message !== undefined && message.display === "bar") {
    const className = classNames("dui-message dui-message-bar", {
      [`dui-message-${message.type}`]: message.type !== undefined,
    });
    return (
      <div className={className}>
        <div className="dui-message-text">
          <div className="dui-message-text-icon">
            {getMessageIcon(message.type)}
          </div>
          <b>{message.title}: </b>
          <div className="dui-message-text-description">
            {message.description}
          </div>
        </div>
        <div className="dui-message-close">
          <Button
            type="text"
            icon={<CloseIcon />}
            onClick={handleMessageCloseClick}
          ></Button>
        </div>
      </div>
    );
  }

  if (message !== undefined && message.display === "toaster") {
    const className = classNames("dui-message dui-message-toaster", {
      [`dui-message-toaster-${message.type}`]: message.type !== undefined,
    });
    return (
      <Snackbar
        className={className}
        open={true}
        autoHideDuration={1500}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={handleMessageCloseClick}
      >
        <div className="dui-message-toaster">
          <div className="dui-message-toaster-icon">
            {getMessageIcon(message.type)}
          </div>
          {message.title !== undefined && (
            <div className="dui-message-toaster-title">{message.title}: </div>
          )}
          <div className="dui-message-toaster-description">
            {message.description}
          </div>
        </div>
      </Snackbar>
    );
  }

  return null;
};

export default Messages;
